import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_FinanceIntegrationService_Dtos_Dashboard_ParticipantDashboardDto,
} from '../../services/wealthlane-finance-integration-services';

const useGetFinanceParticipantDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  filterData: {
    fromDate: string;
    toDate: string;
  }
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_FinanceIntegrationService_Dtos_Dashboard_ParticipantDashboardDto | undefined,
  unknown
> => {
  const { fromDate, toDate } = filterData;
  const financeParticipantDashboard = useQuery(['getFinanceParticipantDashboard'], async () => {
    return await handleRequest(
      DashboardService.getApiFinanceIntegrationApiAppDashboardParticipantDashboard(fromDate, toDate)
    );
  });

  return financeParticipantDashboard;
};

export default useGetFinanceParticipantDashboard;
